export const PENDING_WORKLOAD_ID = "70e6ae7a140de130360d1d6ad17e5467";
export const CARD_WORKLOAD = "Workload";
export const CARD_PILLAR = "Pillar";
export const CARD_QUESTION = "Question";
export const SECURITY_Q1_SECURELY_OPERATE_QUESTION_ID = "securely-operate";
export const SECURITY_Q2_IDENTITIES_QUESTION_ID = "identities";
export const SECURITY_Q3_PERMISSIONS_QUESTION_ID = "permissions";
export const SECURITY_Q4_DETECT_INVESTIGATE_EVENTS_ID =
  "detect-investigate-events";
export const SECURITY_Q5_NETWORK_PROTECTION_ID = "network-protection";
export const SECURITY_Q6_PROTECT_COMPUTE_ID = "protect-compute";
export const SECURITY_Q7_DATA_CLASSIFICATION_ID = "data-classification";
export const SECURITY_Q8_PROTECT_DATA_REST = "protect-data-rest";
export const SECURITY_Q9_PROTECT_DATA_TRANSIT = "protect-data-transit";
export const PERFORMANCE_Q1_PERFORMING_ARCHITECTURE = "performing-architecture";
export const PERFORMANCE_Q6_CONTINUE_HAVING_APPROPRIATE_RESOURCE_TYPE =
  "continue-having-appropriate-resource-type";

export const PERFORMANCE_Q7_MONITOR_INSTANCES_POST_LAUNCH =
  "monitor-instances-post-launch";
export const WAFR_ASSESSMENT_REPORT_NAME =
  "DAY2_Well_Architected_Review___Assessment_Report___HumanTech_Production_Workload";
export const WAFR_FINDING_REPORT_NAME =
  "DAY2_Well_Architected_Review___Findings_Report___HumanTech_Production_Workload";

export const SUSTAINABILITY_Q2_SUS_USER = "sus_user";
export const SUSTAINABILITY_Q3_SUS_SOFTWARE = "sus_software";

export const SUSTAINABILITY_Q4_SUS_DATA = "sus_data";
export const RELIABILITY_Q2_PLANNING_NETWORK_TOPOLOGY =
  "planning-network-topology";
export const RELIABILITY_Q3_SERVICE_ARCHITECTURE = "service-architecture";
export const RELIABILITY_Q5_MITIGATE_INTERACTION_FAILURE =
  "mitigate-interaction-failure";

export const RELIABILITY_Q6_MONITOR_AWS_RESOURCES = "monitor-aws-resources";
export const RELIABILITY_Q9_BACKING_UP_DATA = "backing-up-data";
export const RELIABILITY_Q10_FAULT_ISOLATION = "fault-isolation";

export const RELIABILITY_Q11_WITHSTAND_COMPONENT_FAILURES =
  "withstand-component-failures";
export const COST_Q4_DECOMISSIONING_RESOURCES = "decomissioning-resources";
export const COST_Q5_SELECT_SERVICE = "select-service";

export const COST_Q9_MANAGE_DEMAND_RESOURCES = "manage-demand-resources";
export const OPERATIONAL_Q4_TELEMETRY = "telemetry";
export const OPERATIONAL_Q5_DEV_INTEG = "dev-integ";
export const OPERATIONAL_Q8_WORKLOAD_HEALTH = "workload-health";

export const OPERATIONAL_Q10_EVENT_RESPONSE = "event-response";
